// libs
import React from 'react'

// interfaces / constants

// components
import LoadingSpinnerWrapper from 'src/components/loading_spinner/loading_spinner_wrapper'
import FeedWrapper from 'src/containers/smart_components/list_wrapper/feed_wrapper'

// helpers
import { EventFragment } from '@lopo-tech/lopo-api'
import BannerFeed from 'src/components/feed/layouts/banner_feed/banner_feed'
import { useIsEventCreationEnabled } from 'src/hooks/useIsEventCreationEnabled'
import { useGetRenderEventCreate } from './hooks'

interface IProps {
  getNextPage: () => void;
  isPostCreateOpen?: boolean;
  loading: boolean;
  eventFeedData: EventFragment[];
  onVisibleChange?: (id: string, inView: boolean) => void
}

const EventFeed: React.FC<IProps> = ({
  getNextPage,
  isPostCreateOpen = false,
  loading,
  eventFeedData,
  onVisibleChange
}) => {
  const renderPostCreate = useGetRenderEventCreate(isPostCreateOpen)
  const isEventCreationEnabled = useIsEventCreationEnabled()

  return (
    <LoadingSpinnerWrapper isLoading={loading}>
      <FeedWrapper getNextPage={getNextPage}>
        <BannerFeed
          // todo: add correct category here? could set the filter label at navigation time. would get lost with reload/deep links
          groups={[{ category: { name: ' ', slug: '' }, events: eventFeedData }]}
          renderPostCreate={isEventCreationEnabled ? renderPostCreate : undefined}
          isLoading={loading}
          showGroupLabels
          onVisibleChange={onVisibleChange}
        />
      </FeedWrapper>
    </LoadingSpinnerWrapper>
  )
}

EventFeed.displayName = 'EventFeed'

export default EventFeed
